export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 py-24 md:py-32">
      <div className="text-[11px] tracking-editorial uppercase text-[#C3B1C5]">◈ Our Story</div>
      <h1 className="font-serif-display text-[42px] md:text-[64px] tracking-tight leading-none mt-3">Why ONE LOOK?</h1>
      <div className="divider-thin w-24 mt-8" />
      <div className="mt-10 space-y-6 text-[15px] leading-[1.9] text-[#4A464A]/85">
        <p>Getting dressed shouldn't be complicated.</p>
        <p>ONE LOOK was created for women who love looking put-together without spending forever deciding what matches. Every look is thoughtfully paired so you can spend less time styling and more time living.</p>
        <p>We're a small Singapore label with soft, feminine aesthetics inspired by 白月光 — the pale moonlight. Made for dates, brunches, work, weekends, travel and everything in between.</p>
      </div>
      <p className="mt-10 italic text-[16px]" style={{ color: "#C3B1C5" }}>one look, effortlessly you.</p>
    </div>
  );
}
